import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'baseSubmit',
  props: {
  title: {
    type: String,
    required: true,
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: true,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  className: {
    type: String,
    default: "",
  },
  isChangeData: {
    type: Boolean,
    required: false,
    default: false,
  },
  dataCyId: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(_component_b_button, {
    "data-cy": __props.dataCyId,
    type: "submit",
    class: _normalizeClass(['btn-submit', __props.className, '']),
    disabled: !__props.isChangeData || __props.isLoading
  }, {
    default: _withCtx(() => [
      (__props.isLoading)
        ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
            key: 0,
            class: _normalizeClass('tw-h-[36px] tw-w-full'),
            "animation-data": _unref(ProgressAnimation),
            "auto-play": true,
            loop: true
          }, null, 8, ["animation-data"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(__props.title), 1)
    ]),
    _: 1
  }, 8, ["data-cy", "class", "disabled"]))
}
}

})